import { render, staticRenderFns } from "./information.module.vue?vue&type=template&id=69c68071&scoped=true"
import script from "./information.module.vue?vue&type=script&lang=js"
export * from "./information.module.vue?vue&type=script&lang=js"
import style0 from "./information.module.vue?vue&type=style&index=0&id=69c68071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c68071",
  null
  
)

export default component.exports